export function VehicleColumn({ year, make, model }) {
	let make_model = make;

	if (model) make_model += ` ${model}`;

	return year || make_model ? `${year || ''} ${make_model || ''}` : 'N/A';
}
